import type { PokerRelatedEvents } from '@ps/web-martech-cms-types';
import { isEmpty } from 'lodash';

const mapRelatedEvents = (
  events: PokerRelatedEvents[],
  isMainEvent: boolean
): PokerRelatedEvents[] =>
  events.filter((event) => {
    let include = !event.disabled && !isEmpty(event.path) && Number.isFinite(event.value);
    if (!isMainEvent) {
      include = include && event.type !== 'Satellites';
    }
    return include;
  });

export default mapRelatedEvents;
